import NumberFormat from 'react-number-format';

import { cn, DefaultTooltip } from 'twyne-new.ui';

import { weekOfMonthFormatter } from '@Components/hierarchical-report/utils'
import { formatDate as defaultFormatDate } from 'utils';

import { usePivotData } from '../Context';

function Vertical({ children, height, className, ...props }) {
  return <th className={cn('w-[20px] border twy-border-base-accent p-1', className)} {...props}>
    <span className="inline-block truncate px-1 py-2 capitalize font-semibold" style={{ maxHeight: height * 18 }}>
      {children}
    </span>
  </th>
}

function Horizontal({ children, className, ...props }) {
  return <th className={cn('min-w-0 max-w-40 border twy-border-base-accent py-1 px-2 text-center align-middle capitalize font-semibold', className)} {...props}>
    {children}
  </th>
}

function Th({ id, row: _row, children, colorWeigth, className, ...props }) {
  const backgroundClass = headerLevelBackgroundClass(colorWeigth)
  const cell = <th
    id={id}
    className={cn(
      'min-w-0 max-w-40 truncate border twy-border-base-accent py-1 px-2 text-center align-middle uppercase',
      id.includes('row') ? 'border-t' : 'border-l',
      backgroundClass,
      className,
    )}
    {...props}
  >
    {children || 'N/A'}
  </th>
  if (!children) return cell
  return <DefaultTooltip content={children} triggerProps={{ asChild: true }}>
    {cell}
  </DefaultTooltip>
}

function Td({ children, colorStyle, className, ...props }) {
  return <td className={cn('min-w-0 max-w-40 border twy-border-base-accent p-1 text-center align-middle', className)} {...props} style={{ ...colorStyle }}>{children}</td>
}

function Total({ th, children, className, ...props }) {
  const backgroundClass = headerLevelBackgroundClass(5)
  if (th) return <th className={cn('min-w-0 max-w-40 border twy-border-base-accent p-1 px-2 text-center align-middle font-bold uppercase', backgroundClass, className)} {...props}>{children}</th>
  return <td className={cn('min-w-0 max-w-40 border twy-border-base-accent p-1 text-center align-middle font-semibold uppercase', backgroundClass, className)} {...props}>{children}</td>
}

function Empty({ className, ...props }) {
  return <th className={cn('empty min-w-0 max-w-40 p-1 align-middle', className)} {...props}></th>
}

function Formatter({ children }) {
  const { formatter } = usePivotData()

  if ([null, undefined, ''].includes(children)) return '';

  if (formatter === "money") {
    return <NumberFormat
      value={Number(children).toFixed(2)}
      displayType="text"
      thousandSeparator=","
      decimalSeparator="."
      prefix={'$'}
      decimalScale={2}
      fixedDecimalScale={true}
    />
  }

  return <>{children}</>
}

const headerLevelBackgroundClass = level => {
  const i = Math.min(4, Math.max(0, Number(level)))
  return i === 0 ? 'bg-transparent' : 'twy-subtle-neutral'
}

const formatDefault = (name, value) => `[#${value}] ${name}`
const formatDate = (key, value) => {
  if (key === 'hour') return defaultFormatDate(parseInt(value), 'MM/DD/YYYY [at] HH:mm')
  if (key === 'day') return defaultFormatDate(parseInt(value))
  if (key === 'month') return defaultFormatDate(parseInt(value), 'MM/YYYY')
  if (key === 'week') return weekOfMonthFormatter(parseInt(value))
}

export {
  Vertical,
  Horizontal,
  Th,
  Td,
  Total,
  Empty,
  Formatter,
  formatDefault,
  formatDate,
}
